/*
 *
 * OperationLoyalty
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 24-Jul-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { formatFiscalAmount } from 'Utility/numberMethods'
import OperationLoyaltyBonusList from 'Components/OperationLoyaltyBonusList'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage, { captions } from './languageModule'
import './OperationLoyalty.scss'

const OperationLoyalty = ({ info, isLoading, currency }) => {
  const intl = useIntl()
  const fields = {
    XLSTransactionId: info?.xlsTransactionId,
    totalRedeemedPoints: info?.totalRedeemedPoints && info?.selectedOffers && info.selectedOffers.length > 0 ? `${info?.totalRedeemedPoints} ${intl.formatMessage(captions.points)}` : '-',
    totalAwardedPoints: info?.totalAwardedPoints ? `${info?.totalAwardedPoints} ${intl.formatMessage(captions.points)}` : '-',
    totalRedemptionAmount: info?.totalRedemptionAmount && info?.selectedOffers && info.selectedOffers.length > 0 && currency ? formatFiscalAmount(info?.totalRedemptionAmount, currency) : '-',
    discountedPaymentAmount: info?.finalAmount && currency ? formatFiscalAmount(info?.finalAmount, currency) : '-'
  }
  return (
    <>
      <div className='text_field_section'>
        {fields &&
        Object.entries(fields).map(([field, value]) => (
          <PortalTextBlocked
            key={`operation-additional-info-field-${field}`}
            label={formattedMessage[field]}
            value={value || '-'}
            isLoading={isLoading}
            noPadding
          />
        ))}
      </div>
      {info?.selectedOffers && info.selectedOffers.length > 0 && (
        <OperationLoyaltyBonusList selectedOffers={info.selectedOffers} currency={currency} isLoading={isLoading} />
      )}
    </>
  )
}

OperationLoyalty.propTypes = {
  info: PropTypes.object,
  isLoading: PropTypes.bool,
  currency: PropTypes.string
}

OperationLoyalty.defaultProps = {
  info: {},
  isLoading: false,
  currency: null
}

export default OperationLoyalty
